import * as React from 'react';
import ToastWrapper from './toasts/ToastWrapper';
import { Intent } from './toasts/ToastWrapper';
import { AdminUser } from '../utils/types';

type Props = {};

type State = {
  modalOpen: boolean;
  drawerOpen: boolean;
  toastText?: string;
  intent?: Intent;
  user: AdminUser;
  breadcrumbOverride?: string;
  closeModal: () => void;
  toggleDrawer: () => void;
  openDrawer: () => void;
  closeDrawer: () => void;
  addToast: (text: string, intent: Intent) => void;
  setUser: (user: AdminUser) => void;
  setBreadcrumbOverride: (label?: string) => void;
};

const defaultValues = {
  modalOpen: false,
  drawerOpen: true,
  user: null,
  closeModal: () => null,
  toggleDrawer: () => null,
  openDrawer: () => null,
  closeDrawer: () => null,
  addToast: () => null,
  setUser: (user: AdminUser) => null,
  setBreadcrumbOverride: () => null,
};

export const SteynCityContext = React.createContext<State>(defaultValues);

class ContextProvider extends React.Component<Props, State> {
  state: State = {
    modalOpen: true,
    drawerOpen: false,
    user: null,
    closeModal: () =>
      this.setState({
        modalOpen: false,
      }),
    toggleDrawer: () =>
      this.setState({
        drawerOpen: !this.state.drawerOpen,
      }),
    closeDrawer: () =>
      this.setState({
        drawerOpen: false,
      }),
    openDrawer: () =>
      this.setState({
        drawerOpen: false,
      }),
    addToast: (text: string, intent: Intent) =>
      this.setState(
        {
          toastText: text,
          intent,
        },
        () => {
          // prettier-ignore
          setTimeout(() => {
            this.setState({ toastText: undefined });
          }, 350);
        }
      ),
    setUser: (user: AdminUser) => this.setState({ user }),
    setBreadcrumbOverride: (breadcrumbOverride?: string) => {
      if (this.state.breadcrumbOverride === breadcrumbOverride) {
        return;
      }
      this.setState({ breadcrumbOverride });
    },
  };

  render() {
    const { toastText, intent } = this.state;
    return (
      <SteynCityContext.Provider value={this.state}>
        {this.props.children}
        <ToastWrapper text={toastText} intent={intent} />
      </SteynCityContext.Provider>
    );
  }
}

export default ContextProvider;



// WEBPACK FOOTER //
// ./src/components/ContextProvider.tsx